import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex flex-col items-center justify-center h-screen mt-4",
  id: "report"
}

import ReportButton from "./ReportButton.vue";
import { ref, reactive } from "vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";
import { Modal } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import axios from "axios";
import {
  downloadEmergenza,
  downloadReport, previewEmergenza, previewReport
} from "../../../../EshJSLib/services/donwloadService";
import { fhirOperations } from "../../../../EshJSLib/services/fhirServices";

interface ModalStatus {
  report: boolean;
  emergenza: boolean;
  alert: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportPage',
  setup(__props) {

const store = patientStore();
const { patient } = storeToRefs(store);
const loading = ref(false);
let alertStatus = ref('');
const alertModal = ref<InstanceType<typeof AlertModal> | null>(null);

const isShowModal: ModalStatus = reactive({
  report: false,
  emergenza: false,
  alert:false,
});

function openReportModal() {
  alertModal.value.openModal("Scaricare Report?", true).then((input) => {
    if(input) {
      downloadReport(store.patient.id_paziente)
    }
  })
}

function openEmergenzaModal() {
  alertModal.value.openModal("Scaricare Report di Emergenza?", true).then((input) => {
    if(input) {
      downloadEmergenza(store.patient.id_paziente)
    }
  })
}

function fhirOperate(type: string) {
  fhirOperations(type, patient.value.paziente_nome + '_' + patient.value.paziente_cognome).then(response => {
    console.log(response);
  }, error => {
    console.log(error);
  })
}

function preview(type) {
  if(type == 'report') {
    previewReport(store.patient.id_paziente);
  } else {
    previewEmergenza(store.patient.id_paziente);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ReportButton, {
      id: "clinical",
      class: "custom-button",
      title: "Report",
      onPreview: _cache[0] || (_cache[0] = ($event: any) => (preview('report'))),
      onOpenModal: openReportModal
    }),
    _createVNode(ReportButton, {
      id: "RdE",
      class: "custom-button mt-4",
      title: "Report di Emergenza",
      onPreview: _cache[1] || (_cache[1] = ($event: any) => (preview('emergenza'))),
      onOpenModal: openEmergenzaModal
    }),
    _createVNode(ReportButton, {
      id: "fhir",
      class: "custom-button mt-4",
      title: "Report di Fhir",
      onPreview: _cache[2] || (_cache[2] = ($event: any) => (fhirOperate('preview'))),
      onOpenModal: _cache[3] || (_cache[3] = ($event: any) => (fhirOperate('download')))
    }),
    _createVNode(AlertModal, {
      ref_key: "alertModal",
      ref: alertModal
    }, null, 512)
  ]))
}
}

})